import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import { forwardRef, useMemo } from 'react';
import { blanketColor, overlayZindex } from './styles';
import { ellipsis, hideControlsClassName } from '@atlaskit/media-ui';
import { TouchScrollable } from 'react-scrolllock';
import { useMergeRefs } from 'use-callback-ref';
import { headerAndSidebarBackgroundColor } from './viewers/modalSpinner';
import { ArchiveSideBarWidth } from './viewers/archiveSidebar/styles';
import { borderRadius } from '@atlaskit/theme/constants';
import { Box, xcss } from '@atlaskit/primitives';
var SIDEBAR_WIDTH = 416;
var blanketStyles = css({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundColor: blanketColor,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: overlayZindex,
  display: 'flex'
});
var headerWrapperStyles = function headerWrapperStyles(_ref) {
  var isArchiveSideBarVisible = _ref.isArchiveSideBarVisible;
  return css({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '98px',
    opacity: 0.85,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: "linear-gradient( to bottom, ".concat(headerAndSidebarBackgroundColor, ", rgba(14, 22, 36, 0) ) no-repeat"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundPosition: isArchiveSideBarVisible ? "".concat(ArchiveSideBarWidth, "px 0") : '0',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    color: '#c7d1db',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    padding: "var(--ds-space-300, 24px)",
    boxSizing: 'border-box',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: overlayZindex + 1
  });
};
var listWrapperStyles = css({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
var closeButtonWrapperStyles = css({
  position: 'absolute',
  top: "var(--ds-space-300, 24px)",
  right: "var(--ds-space-250, 20px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: overlayZindex + 2
});
var contentWrapperStyles = function contentWrapperStyles(_ref2) {
  var isSidebarVisible = _ref2.isSidebarVisible;
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: isSidebarVisible ? "calc(100% - ".concat(SIDEBAR_WIDTH, "px)") : '100%'
  });
};
var zoomWrapperStyles = css({
  width: '100%',
  position: 'absolute',
  bottom: '0px',
  height: '98px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundImage: "linear-gradient( to top, ".concat(headerAndSidebarBackgroundColor, ", rgba(14, 22, 36, 0) )"),
  opacity: 0.85,
  pointerEvents: 'none',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'flex-end',
  padding: "var(--ds-space-100, 10px)".concat(" ", "var(--ds-space-300, 24px)")
});
var zoomCenterControlsStyles = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  gap: "var(--ds-space-100, 10px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> *': {
    pointerEvents: 'all'
  }
});
var zoomRightControlsStyles = css({
  position: 'absolute',
  right: "var(--ds-space-300, 24px)",
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  color: '#c7d1db',
  pointerEvents: 'all',
  display: 'flex',
  justifyContent: 'right',
  gap: "var(--ds-space-100, 10px)"
});
var zoomLevelIndicatorStyles = css({
  height: '32px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: '32px',
  verticalAlign: 'middle'
});
var hdIconGroupWrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-100, 10px)",
  position: 'relative',
  width: '24px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> *': {
    position: 'absolute'
  }
});
var errorMessageWrapperStyles = css({
  textAlign: 'center',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  color: '#c7d1db',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  p: {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '100%'
  }
});
var errorImageStyles = css({
  marginBottom: "var(--ds-space-100, 10px)",
  userSelect: 'none'
});
var videoStyles = css({
  width: '100vw',
  height: '100vh'
});
var pdfWrapperStyles = css(_defineProperty({
  overflow: 'auto',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
}, ".".concat(hideControlsClassName), {
  position: 'fixed'
}));
var arrowStyles = css({
  cursor: 'pointer',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  svg: {
    filter: 'drop-shadow(0px 1px 1px rgb(9 30 66 / 25%)) drop-shadow(0px 0px 1px rgb(9 30 66 / 31%))'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&& button': {
    '&:hover': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      svg: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#b6c2cf'
      }
    },
    '&:active': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      svg: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#c7d1db'
      }
    }
  }
});
var arrowWrapperStyles = css({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  padding: "var(--ds-space-250, 20px)"
});
var arrowsWrapperStyles = css({
  display: 'flex',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  left: 0,
  width: '100%'
});
var leftWrapperStyles = function leftWrapperStyles(_ref3) {
  var isArchiveSideBarVisible = _ref3.isArchiveSideBarVisible;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    css(arrowWrapperStyles, {
      textAlign: 'left',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      left: isArchiveSideBarVisible ? "".concat(ArchiveSideBarWidth, "px") : '0'
    })
  );
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var rightWrapperStyles = css(arrowWrapperStyles, {
  textAlign: 'right',
  right: 0
});
var headerStyles = function headerStyles(_ref4) {
  var isArchiveSideBarVisible = _ref4.isArchiveSideBarVisible;
  return css({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    paddingLeft: isArchiveSideBarVisible ? "".concat(ArchiveSideBarWidth, "px") : '0'
  });
};
var leftHeaderStyles = css({
  flex: 1,
  overflow: 'hidden',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> *': {
    pointerEvents: 'all'
  }
});
var imageWrapperStyles = css({
  width: '100vw',
  height: '100vh',
  overflow: 'auto',
  textAlign: 'center',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap'
});
var baselineExtendStyles = css({
  height: '100%',
  display: 'inline-block',
  verticalAlign: 'middle'
});
var imgStyles = function imgStyles(_ref5) {
  var cursor = _ref5.cursor,
    shouldPixelate = _ref5.shouldPixelate;
  return css({
    display: 'inline-block',
    verticalAlign: 'middle',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cursor: cursor
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  shouldPixelate ? "/* Prevent images from being smoothed when scaled up */\n    image-rendering: optimizeSpeed; /* Legal fallback */\n    image-rendering: -moz-crisp-edges; /* Firefox        */\n    image-rendering: -o-crisp-edges; /* Opera          */\n    image-rendering: -webkit-optimize-contrast; /* Safari         */\n    image-rendering: optimize-contrast; /* CSS3 Proposed  */\n    image-rendering: crisp-edges; /* CSS4 Proposed  */\n    image-rendering: pixelated; /* CSS4 Proposed  */\n    -ms-interpolation-mode: nearest-neighbor; /* IE8+           */" : "");
};
var medatadataTextWrapperStyles = css({
  overflow: 'hidden'
});
var metadataWrapperStyles = css({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var metadataFileNameStyles = css(ellipsis());
var metadataSubTextStyles = css({
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  color: '#c7d1db'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
ellipsis());
var metadataIconWrapperStyles = xcss({
  paddingTop: 'space.050',
  paddingRight: 'space.150'
});
var rightHeaderStyles = css({
  textAlign: 'right',
  marginRight: "var(--ds-space-500, 40px)",
  minWidth: '200px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> *': {
    pointerEvents: 'all'
  }
});
var customAudioPlayerWrapperStyles = css({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
});
var audioPlayerStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundColor: blanketColor,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius: borderRadius(),
  alignItems: 'center',
  justifyContent: 'center',
  width: '400px',
  height: '400px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative'
});
var audioStyles = css({
  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: 0
});
var audioCoverStyles = css({
  width: '100%',
  height: '100%',
  objectFit: 'scale-down',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  backgroundColor: '#000'
});
var defaultCoverWrapperStyles = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: "var(--ds-text, #9FADBC)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> *': {
    transform: 'scale(2)'
  }
});
var downloadButtonWrapperStyles = css({
  marginTop: "var(--ds-space-300, 28px)",
  textAlign: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  button: {
    '&:hover, &:active': {
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
      color: '#161a1d !important'
    }
  }
});
var customVideoPlayerWrapperStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  video: {
    flex: 1,
    width: '100vw',
    height: '100vh',
    maxHeight: '100vh'
  }
});
var sidebarWrapperStyles = css({
  top: 0,
  right: 0,
  width: "".concat(SIDEBAR_WIDTH, "px"),
  height: '100vh',
  overflow: 'hidden auto',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  backgroundColor: "var(--ds-surface, ".concat(headerAndSidebarBackgroundColor, ")"),
  color: "var(--ds-text, #c7d1db)"
});
var spinnerWrapperStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%'
});
var formattedMessageWrapperStyles = css({});
// We are keeping this data-testid since JIRA is still using it in their codebase to perform checks. Before removing this, we need to ensure this 'media-viewer-popup' test id is not being used anywhere else in other codebases
export var Blanket = function Blanket(_ref6) {
  var datatestId = _ref6['data-testid'],
    className = _ref6.className,
    children = _ref6.children;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    jsx("div", {
      css: blanketStyles,
      "data-testid": datatestId,
      className: className
    }, children)
  );
};
export var HeaderWrapper = function HeaderWrapper(_ref7) {
  var className = _ref7.className,
    children = _ref7.children,
    isArchiveSideBarVisible = _ref7.isArchiveSideBarVisible;
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    css: headerWrapperStyles({
      isArchiveSideBarVisible: isArchiveSideBarVisible
    })
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className
  }, children);
};
HeaderWrapper.displayName = 'HeaderWrapper';
export var ListWrapper = function ListWrapper(_ref8) {
  var children = _ref8.children;
  return jsx("div", {
    css: listWrapperStyles
  }, children);
};
ListWrapper.displayName = 'ListWrapper';
export var ArrowsWrapper = function ArrowsWrapper(_ref9) {
  var children = _ref9.children;
  return jsx("div", {
    id: "media-viewer-navigation",
    css: arrowsWrapperStyles
  }, children);
};
export var CloseButtonWrapper = function CloseButtonWrapper(_ref10) {
  var className = _ref10.className,
    children = _ref10.children;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    jsx("div", {
      css: closeButtonWrapperStyles,
      className: className
    }, children)
  );
};
export var ContentWrapper = function ContentWrapper(_ref11) {
  var isSidebarVisible = _ref11.isSidebarVisible,
    children = _ref11.children;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      css: contentWrapperStyles({
        isSidebarVisible: isSidebarVisible
      })
    }, children)
  );
};
export var ZoomWrapper = function ZoomWrapper(_ref12) {
  var className = _ref12.className,
    children = _ref12.children;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    jsx("div", {
      css: zoomWrapperStyles,
      className: className
    }, children)
  );
};
export var ZoomCenterControls = function ZoomCenterControls(_ref13) {
  var children = _ref13.children;
  return jsx("div", {
    css: zoomCenterControlsStyles
  }, children);
};
export var ZoomRightControls = function ZoomRightControls(_ref14) {
  var children = _ref14.children;
  return jsx("div", {
    css: zoomRightControlsStyles
  }, children);
};
export var ZoomLevelIndicator = function ZoomLevelIndicator(_ref15) {
  var children = _ref15.children;
  return jsx("span", {
    css: zoomLevelIndicatorStyles,
    "data-testid": "zoom-level-indicator"
  }, children);
};
export var HDIconGroupWrapper = function HDIconGroupWrapper(_ref16) {
  var className = _ref16.className,
    children = _ref16.children;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    jsx("div", {
      css: hdIconGroupWrapperStyles,
      className: className
    }, children)
  );
};
export var ErrorMessageWrapper = function ErrorMessageWrapper(_ref17) {
  var datatestId = _ref17['data-testid'],
    children = _ref17.children;
  return jsx("div", {
    css: errorMessageWrapperStyles,
    "data-testid": datatestId
  }, children);
};
export var ErrorImage = function ErrorImage(_ref18) {
  var src = _ref18.src,
    alt = _ref18.alt;
  return jsx("img", {
    css: errorImageStyles,
    alt: alt,
    src: src
  });
};
export var Video = function Video(_ref19) {
  var autoPlay = _ref19.autoPlay,
    controls = _ref19.controls,
    src = _ref19.src;
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    jsx("video", {
      css: videoStyles,
      autoPlay: autoPlay,
      controls: controls,
      src: src
    })
  );
};
var PDFWrapperBody = /*#__PURE__*/forwardRef(function (_ref20, ref) {
  var innerRef = _ref20.innerRef,
    datatestId = _ref20['data-testid'],
    children = _ref20.children;
  var bodyRef = useMergeRefs([ref, innerRef]);
  return jsx("div", {
    css: pdfWrapperStyles,
    ref: bodyRef,
    "data-testid": datatestId
  }, children);
});
export var PDFWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(TouchScrollable, null, jsx(PDFWrapperBody, _extends({
    innerRef: ref
  }, props)));
});
export var Arrow = function Arrow(_ref21) {
  var className = _ref21.className,
    children = _ref21.children;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    jsx("span", {
      css: arrowStyles,
      className: className
    }, children)
  );
};
export var LeftWrapper = function LeftWrapper(_ref22) {
  var children = _ref22.children,
    isArchiveSideBarVisible = _ref22.isArchiveSideBarVisible;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      css: leftWrapperStyles({
        isArchiveSideBarVisible: isArchiveSideBarVisible
      })
    }, children)
  );
};
export var RightWrapper = function RightWrapper(_ref23) {
  var children = _ref23.children;
  return jsx("div", {
    css: rightWrapperStyles
  }, children);
};

// header.tsx

export var Header = function Header(_ref24) {
  var children = _ref24.children,
    isArchiveSideBarVisible = _ref24.isArchiveSideBarVisible,
    className = _ref24.className;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      css: headerStyles({
        isArchiveSideBarVisible: isArchiveSideBarVisible
      }),
      className: className
    }, children)
  );
};
export var LeftHeader = function LeftHeader(_ref25) {
  var children = _ref25.children;
  return jsx("div", {
    css: leftHeaderStyles
  }, children);
};
export var ImageWrapper = /*#__PURE__*/forwardRef(function (_ref26, ref) {
  var children = _ref26.children,
    datatestId = _ref26['data-testid'],
    onClick = _ref26.onClick,
    style = _ref26.style,
    className = _ref26.className;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", {
      "data-testid": datatestId,
      onClick: onClick,
      ref: ref,
      css: imageWrapperStyles
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: style
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: className
    }, children)
  );
});
export var BaselineExtend = function BaselineExtend() {
  return jsx("div", {
    css: baselineExtendStyles
  });
};
export var Img = function Img(_ref27) {
  var canDrag = _ref27.canDrag,
    isDragging = _ref27.isDragging,
    shouldPixelate = _ref27.shouldPixelate,
    datatestId = _ref27['data-testid'],
    src = _ref27.src,
    style = _ref27.style,
    onLoad = _ref27.onLoad,
    onError = _ref27.onError,
    onMouseDown = _ref27.onMouseDown,
    className = _ref27.className;
  var cursor = useMemo(function () {
    if (canDrag && isDragging) {
      return 'grabbing';
    } else if (canDrag) {
      return 'grab';
    } else {
      return 'auto';
    }
  }, [canDrag, isDragging]);
  return (
    // eslint-disable-next-line jsx-a11y/alt-text, jsx-a11y/no-noninteractive-element-interactions
    jsx("img", {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className: className
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
      ,
      css: imgStyles({
        cursor: cursor,
        shouldPixelate: shouldPixelate
      }),
      "data-testid": datatestId,
      src: src
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: style,
      onLoad: onLoad,
      onError: onError,
      onMouseDown: onMouseDown
    })
  );
};
export var MedatadataTextWrapper = function MedatadataTextWrapper(_ref28) {
  var children = _ref28.children;
  return jsx("div", {
    css: medatadataTextWrapperStyles
  }, children);
};
export var MetadataWrapper = function MetadataWrapper(_ref29) {
  var children = _ref29.children;
  return jsx("div", {
    css: metadataWrapperStyles
  }, children);
};
export var MetadataFileName = function MetadataFileName(_ref30) {
  var datatestId = _ref30['data-testid'],
    children = _ref30.children;
  return jsx("div", {
    css: metadataFileNameStyles,
    "data-testid": datatestId
  }, children);
};
export var MetadataSubText = function MetadataSubText(_ref31) {
  var datatestId = _ref31['data-testid'],
    children = _ref31.children;
  return jsx("div", {
    css: metadataSubTextStyles,
    "data-testid": datatestId
  }, children);
};
export var MetadataIconWrapper = function MetadataIconWrapper(_ref32) {
  var children = _ref32.children;
  return jsx(Box, {
    xcss: metadataIconWrapperStyles
  }, children);
};
export var RightHeader = function RightHeader(_ref33) {
  var children = _ref33.children;
  return jsx("div", {
    css: rightHeaderStyles
  }, children);
};
export var CustomAudioPlayerWrapper = function CustomAudioPlayerWrapper(_ref34) {
  var children = _ref34.children;
  return jsx("div", {
    css: customAudioPlayerWrapperStyles
  }, children);
};
export var AudioPlayer = function AudioPlayer(_ref35) {
  var datatestId = _ref35['data-testid'],
    children = _ref35.children;
  return jsx("div", {
    css: audioPlayerStyles,
    "data-testid": datatestId
  }, children);
};
AudioPlayer.displayName = 'AudioPlayer';
export var Audio = /*#__PURE__*/forwardRef(function (_ref36, ref) {
  var autoPlay = _ref36.autoPlay,
    controls = _ref36.controls,
    src = _ref36.src,
    preload = _ref36.preload;
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    jsx("audio", {
      css: audioStyles,
      ref: ref,
      autoPlay: autoPlay,
      controls: controls,
      src: src,
      preload: preload
    })
  );
});
export var AudioCover = function AudioCover(_ref37) {
  var src = _ref37.src,
    alt = _ref37.alt;
  return jsx("img", {
    css: audioCoverStyles,
    alt: alt,
    src: src
  });
};
export var DefaultCoverWrapper = function DefaultCoverWrapper(_ref38) {
  var children = _ref38.children;
  return jsx("div", {
    css: defaultCoverWrapperStyles
  }, children);
};
export var DownloadButtonWrapper = function DownloadButtonWrapper(_ref39) {
  var children = _ref39.children;
  return jsx("div", {
    css: downloadButtonWrapperStyles
  }, children);
};
export var CustomVideoPlayerWrapper = function CustomVideoPlayerWrapper(_ref40) {
  var datatestId = _ref40['data-testid'],
    children = _ref40.children;
  return jsx("div", {
    css: customVideoPlayerWrapperStyles,
    "data-testid": datatestId
  }, children);
};
export var SidebarWrapper = function SidebarWrapper(_ref41) {
  var datatestId = _ref41['data-testid'],
    children = _ref41.children;
  return jsx("div", {
    css: sidebarWrapperStyles,
    "data-testid": datatestId
  }, children);
};
export var SpinnerWrapper = function SpinnerWrapper(_ref42) {
  var children = _ref42.children;
  return jsx("div", {
    css: spinnerWrapperStyles
  }, children);
};
export var FormattedMessageWrapper = function FormattedMessageWrapper(_ref43) {
  var children = _ref43.children;
  return jsx("span", {
    css: formattedMessageWrapperStyles
  }, children);
};